import useGotchiOwner from 'state/vvsgotchi/hooks/useGotchiOwner'
import DashboardSection from 'views/VvsGotchi/components/QuestDashboardSection'
import OnboardSection from 'views/VvsGotchi/components/QuestOnboardSection'
import QuestsIndexSection from 'views/VvsGotchi/components/QuestsIndexSection'

import { LightPageContainer } from '../styles'
import { QuestTopSectionFlex } from './styles'

const Quest: React.FC = () => {
  const { isOnboarded } = useGotchiOwner()

  return (
    <LightPageContainer>
      <QuestTopSectionFlex>
        <DashboardSection />
        {!isOnboarded && <OnboardSection />}
      </QuestTopSectionFlex>
      <QuestsIndexSection />
    </LightPageContainer>
  )
}

export default Quest
